import { render } from "./clinica.vue?vue&type=template&id=28fc2e50"
import script from "./clinica.vue?vue&type=script&lang=js"
export * from "./clinica.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__